import { Card } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import { MultiPicker } from "@/src/components/multiPicker";
import SearchBar from "@/src/components/searchBar";
import {
  FrequentSnomedParent,
  frequentSnomedParents,
  Reference,
  ReferenceCategory,
  SnomedConcept,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, uid } from "@/src/utils/utils";
import { useState } from "react";
import SnomedCategoryName from "./snomedCategoryName";
import SnomedConceptCard from "./snomedConceptCard";
import SnomedConceptCheckbox from "./snomedConceptCheckbox";

export function SnomedConceptsMultiPicker({
  parentIds,
  value,
  onChange,
}: {
  parentIds?: FrequentSnomedParent[];
  value: SnomedConcept[] | null | undefined;
  onChange: (
    newValue: (SnomedConcept | null | undefined)[] | null | undefined
  ) => void;
}) {
  return (
    <MultiPicker
      title="Concept SNOMED"
      queryKey={["snomedConceptsMultiple", parentIds]}
      loadItems={async (limit, offset, searchKey) => {
        return await apiFetch("snomedConcepts", "loadMany", {
          searchKey,
          limit,
          offset,
        });
      }}
      value={value || []}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      getChecboxCardContent={(item) => {
        return (
          <SnomedConceptCard
            concept={item}
            searchKey={""}
            filteredParentIds={parentIds}
          />
        );
      }}
      getChild={(item) => {
        return (
          <Card
            color="blue"
            title={item?.name}
            subTitle={
              <SnomedCategoryName
                concept={item}
                filteredParentIds={parentIds}
              />
            }
          ></Card>
        );
      }}
    ></MultiPicker>
  );
}

export function SnomedConceptsMultiPickerList({
  parentIds,
  currentSearchKey,
  showSearchBar,
  category,
  current,
  onSelect,
}: {
  parentIds?: FrequentSnomedParent[];
  currentSearchKey?: string;
  showSearchBar?: boolean;
  category: ReferenceCategory;
  current: (SnomedConcept | null | undefined)[] | null | undefined;
  onSelect: (concepts: SnomedConcept[]) => void;
}) {
  const [reload, setReload] = useState(0);
  const [searchKey, setSearchKey] = useState(currentSearchKey || "");
  const [selectedConcepts, setSelectedConcepts] = useState(current || []);

  function toggleConcept(concept: SnomedConcept) {
    let newSelectedConcepts = [...selectedConcepts];
    if (
      newSelectedConcepts.find((c) => getItemId(c) == getItemId(concept)) !=
      null
    ) {
      newSelectedConcepts = newSelectedConcepts.filter(
        (c) => getItemId(c) != getItemId(concept)
      );
    } else {
      newSelectedConcepts.push(concept);
    }
    setSelectedConcepts(newSelectedConcepts);
    onSelect(newSelectedConcepts.filter((c) => c != null) as SnomedConcept[]);
  }

  return (
    <div className="grid c1 gap10">
      {showSearchBar != false && (
        <SearchBar
          value={searchKey}
          placeholder="Rechercher un élément..."
          onChange={(newValue) => {
            setSearchKey(newValue || "");
          }}
        ></SearchBar>
      )}

      <InfiniteFetchableList
        queryKey={[
          "SnomedConceptsMultiPickerList",
          searchKey,
          reload,
          JSON.stringify(parentIds),
          category,
        ]}
        limit={40}
        getFunction={(limit, offset, searchKey) =>
          apiFetch(
            "snomedConcepts",
            "loadMany",
            {
              searchKey,
              limit,
              offset,
              parentIds: parentIds?.map(
                (parent) => frequentSnomedParents[parent].id
              ),
            },
            "Erreur lors du chargement des motifs"
          )
        }
        searchKey={searchKey}
        emptyChild={
          <div className="grid c1 gap10">
            {searchKey.length < 3 ? (
              <div className=" p20 tcenter">
                Veuillez saisir au moins <strong>3 lettres</strong>
              </div>
            ) : (
              <div className="gray p20 center">
                Aucun élément trouvé
                <strong>{searchKey && `content ${searchKey}`}</strong>
              </div>
            )}
          </div>
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((concept) => {
              const isActive =
                selectedConcepts.find(
                  (c) => getItemId(c) == getItemId(concept)
                ) != null;
              return (
                <SnomedConceptCheckbox
                  key={uid()}
                  filteredParentIds={parentIds}
                  searchKey={searchKey}
                  isActive={
                    selectedConcepts.find(
                      (c) => getItemId(c) == getItemId(concept)
                    ) != null
                  }
                  concept={concept}
                  onClick={async () => {
                    if (!concept.id) return;
                    toggleConcept(concept);
                   
                  }}
                />
              );
            })}
          </div>
        )}
      </InfiniteFetchableList>
    </div>
  );
}

export async function openSnomedConceptsMultiPicker({
  title,
  parentIds,
  category,
  current,
  onConfirm,
}: {
  title: string;
  parentIds?: FrequentSnomedParent[];
  category: ReferenceCategory;
  current: (SnomedConcept | null | undefined)[] | null | undefined;
  onConfirm: (reference: Reference[]) => void;
}) {
  current ||= [];
  await openDrawer({
    id: "snomedConceptsMultiPickerDrawer",
    title,
    additionalClasses: ["small"],
    content: (
      <SnomedConceptsMultiPickerList
        parentIds={parentIds}
        current={current}
        category={category}
        onSelect={(selectedConcepts) => {
          current = selectedConcepts;
          console.log("theeee current", current);
        }}
      ></SnomedConceptsMultiPickerList>
    ),
    onConfirm: async () => {
      const references = await apiFetch(
        "references",
        "upsertManyUsingSnomedConcepts",
        {
          category,
          conceptIds: current?.map((c) => getItemId(c)) || [],
        }
      );

      closeDrawer("snomedConceptsMultiPickerDrawer");
      onConfirm(references);
    },
  });
}
